/**
 * Después de un 401 el interceptor renueva el token y avisa que los permisos (`/me/scope`) quedaron
 * viejos, y ese aviso vuelve a pedirlos. Si el 401 es del propio `/me/scope`, avisar otra vez lo
 * vuelve a pedir, otro 401, y así sin fin: le pasaba a quien inicia sesión sin rol.
 */
export function shouldInvalidateScopeAfter401(url: string | undefined): boolean {
  if (!url) return false;
  const ruta = url.split("?")[0];
  return !ruta.endsWith("/me/scope");
}
